import PropTypes from 'prop-types';
import React from 'react';

import { PRIMARY_BLUE } from '@wetransfer/transfer/constant/colors';

const Cli = ({ width, color }) => (
  <svg width={width} height={width} viewBox="0 0 38 38">
    <path
      fill={color}
      fillRule="evenodd"
      d="M5 0h28c2.76 0 5 2.24 5 5v28c0 2.76-2.24 5-5 5H5c-2.76 0-5-2.24-5-5V5c0-2.76 2.24-5 5-5zm1.282 15.304c-.385.397-.374 1.03.022 1.414.397.385 1.03.374 1.414-.022l4-4.13c.385-.397.374-1.03-.023-1.415l-4-3.87c-.397-.383-1.03-.372-1.414.025-.383.397-.372 1.03.025 1.414l3.28 3.173-3.303 3.41zM19 16h-5c-.552 0-1 .448-1 1s.448 1 1 1h5c.552 0 1-.448 1-1s-.448-1-1-1z"
    />
  </svg>
);

Cli.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Cli.defaultProps = {
  color: PRIMARY_BLUE,
  width: 38,
};

export default Cli;
